import type { IconProps } from './types';

/**
 * 入力欄のパスワード表示切替（非表示状態）用の斜線付き目アイコン。16px・グレー。ペアは `IconEyeOpen`。
 */
export const IconEyeOff = ({ width, height, color = '#A3A3A3', className }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M6.58659 6.58659C6.39009 6.76969 6.23248 6.99049 6.12317 7.23582C6.01386 7.48115 5.95508 7.74599 5.95034 8.01453C5.94561 8.28307 5.995 8.54981 6.09559 8.79885C6.19618 9.04788 6.3459 9.27411 6.53582 9.46402C6.72574 9.65394 6.95196 9.80366 7.20099 9.90425C7.45003 10.0048 7.71677 10.0542 7.98531 10.0495C8.25386 10.0448 8.51869 9.98598 8.76402 9.87667C9.00935 9.76736 9.23016 9.60975 9.41325 9.41325M7.15332 3.38667C7.43419 3.35167 7.71694 3.33386 7.99999 3.33333C12.6667 3.33333 14.6667 8 14.6667 8C14.3686 8.63808 13.9948 9.23795 13.5533 9.78667M4.40667 4.40674C3.08083 5.30982 2.01991 6.55024 1.33333 8.00007C1.33333 8.00007 3.33333 12.6667 8 12.6667C9.27727 12.6702 10.5272 12.2968 11.5933 11.5934M1.33333 1.33333L14.6667 14.6667'
        stroke={color}
        strokeWidth='1.33'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
